import { type Label, type Maybe } from "../../../gql-generated/types";

export class LensLabels {
    public static scheduleV3AliasKey: string = "ScheduleV3NsAlias";

    public static getScheduleV3Alias(labels: readonly Maybe<Label>[]) {
        const aliasLabel = labels.find((label) => label?.key === LensLabels.scheduleV3AliasKey);
        return aliasLabel ? aliasLabel.value : null;
    }
}
